import React, { useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import Wizard from './Wizard'
import { ProjectProvider } from './NewProjectContext'
import UploadSelectFilesStep from './UploadSelectFilesStep'
import UploadFinalizeStep from './UploadFinalizeStep'
import styled from 'styled-components'
import UploadDatasetNameStep from './UploadDatasetNameStep'
import { clearError, clearSelectedFiles, clearUploadStats, resetSelectedFiles } from '../../store/slices/datasetSlice'
import { useAppDispatch } from '../../store/hooks'

const StyledModal = styled(Modal)`
  .modal-content {
    background: #1a1a1a;
    border: none;
  }

  .modal-header {
    background: linear-gradient(45deg, #402563, #114ee0);
    border-bottom: none;
    padding: 1.25rem 1.5rem;

    .modal-title {
      color: white;
      font-weight: 600;
      font-size: 1.25rem;
    }

    .btn-danger {
      background: transparent;
      border: 1px solid rgba(255, 255, 255, 0.2);
      padding: 0.5rem 1rem;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.3);
      }
    }
  }

  .modal-body {
    padding: 0;
    background: #2a2a2a;
  }
`

interface UploadWizardProps {
  show: boolean
  onHide: () => void
}

const UploadWizard: React.FC<UploadWizardProps> = ({ show, onHide }) => {
  const dispatch = useAppDispatch()
  const handleCancel = () => {
    onHide()
  }

  const steps = () => {
    const s = [
      {
        name: 'Dataset Name',
        component: UploadDatasetNameStep,
        title: 'Choose Dataset',
        description: 'Select or create a dataset for your images',
      },
      {
        name: 'Add Data',
        component: UploadSelectFilesStep,
        title: 'Add Data',
        description: 'Add your images and optional labels file',
      },
      {
        name: 'Review',
        component: UploadFinalizeStep,
        title: 'Review & Upload',
        description: 'Review your selections and start the upload',
      },
    ]
    return s
  }

  useEffect(() => {
    dispatch(clearError())
  })

  return (
    <StyledModal show={show} onHide={onHide} centered size="xl" className="upload-wizard-modal">
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <Modal.Title>Upload Dataset</Modal.Title>
        <Button variant="danger" onClick={handleCancel}>
          Cancel
        </Button>
      </Modal.Header>
      <Modal.Body>
        <ProjectProvider>
          <Wizard steps={steps()} stepProps={{ onHide, singleSelect: true }} />
        </ProjectProvider>
      </Modal.Body>
    </StyledModal>
  )
}

export default UploadWizard
